/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { connect } from 'react-redux';
import { string, shape, arrayOf } from 'prop-types';
import { compose } from 'recompose';
import ReactMarkdown from 'react-markdown';
import mbpLogger from 'mbp-logger';
import { useQuery } from '@apollo/react-hooks';
import GraphqlPDPPromotionalBlock from './GraphqlPDPPromotionBlock';
import { getBrand } from '../../../../../../state/ducks/App/ducks/Brand/Brand-Selectors';
import findContent from '../../../../../gql/queries/findContent';

const GraphqlPDPPromoDataContainer = ({
    brand, parentCategories,
}) => {
    const FIND_PROMO_QUERY = findContent({
        brand: brand?.domain,
        contentType: 'promo_messaging',
    });

    let response = null;

    const { loading, error, data } = useQuery(FIND_PROMO_QUERY);

    if (loading) {
        response = null;
    }
    if (error) {
        mbpLogger.logError({
            jsError: error,
            message: 'Failed load promo container',
        });
        response = <ReactMarkdown source="There has been an error retrieving details for this promotion. If this issue persists, please contact us." />;
    }

    const promoData = data?.findContent?.content?.entries;

    if (promoData?.length) {
        // finds the category id zinside the parentCategories - if found displays that promo summary
        const promoSummary = promoData.find((promo) => parentCategories?.some((category) => promo?.category_id?.includes(category?.id))) || null;
        response = promoSummary ? <GraphqlPDPPromotionalBlock promoSummary={promoSummary} /> : null;
    }

    return response;
};

GraphqlPDPPromoDataContainer.propTypes = {
    brand: string.isRequired,
    categoryId: string,
    parentCategories: arrayOf(shape({
        id: string,
    })).isRequired,
};

GraphqlPDPPromoDataContainer.defaultProps = {
    categoryId: '',
};

const mapStateToProps = (state) => ({
    brand: getBrand(state),
});

const enhance = compose(
    connect(mapStateToProps),
);

export default enhance(GraphqlPDPPromoDataContainer);
